/**
 * This file contains jQuery utility methods. These are small distinct functions 
 * that are more than likely not tied to the UI.
 */
(function ($) {
    // Debugging methods
    $.fn.dumpStack = function (title, content) {
        if (this.length == 0) {
            log('dumpStack ' + (title ? '(' + title + ') ' : '') + 'empty');
        } else {
            log('dumpStack ' + (title ? '(' + title + ') ' : '') + this.length);
            this.each(function (i) {
                log(i + ': '
								+ this.tagName
								+ (this.id ? '#' + this.id : '')
								+ (this.className != '' ? '.' + this.className.replace(/\s/g, '.') : '')
								+ ($(this).is(':input') ? ' VAL[' + $(this).val() + ']' : '')
								+ (title === true || content ? ' HTML[' + $(this).html().substr(0, 45) + '...]' : ''));
            });
            log('dumpStack (end)');
        }
        return this;
    };

    // Given two classes, will replace one with the second
    // Third argument specifies if the first class is required for
    // the second to be added
    $.fn.swapClass = function (c1, c2, requireFirst) {
        return this.each(function () {
            if (requireFirst === false || $(this).hasClass(c1)) {
                var c = $(this).attr('class');
                c = c.replace(new RegExp('(^|\\\s+)' + c1 + '(\\\s+|$)'), '$1' + c2 + '$2');
                $(this).attr('class', c);
            }
        });
    };

    /*
    * This utility method is similar to bind with the exception that it 
    * adds the event as the first entry in the events queue
    */
    $.fn.bindFirst = function (eventName, callback) {
        return this.each(function () {
            // Get a copy of bound events
            var events = $.extend(true, {}, $(this).data('events') || {});
            // Unbind existing events, then bind our callback
            $(this).unbind(eventName).bind(eventName, callback);
            // Get a new copy of bound events
            var events2 = $(this).data('events');
            if (typeof events2 == 'object') {
                // Merge our new handler, and existing events
                $.extend(true, events2[eventName], events[eventName] || {});
                // Reassign the events data
                $(this).data('events', events2);
            }
        });
    };

    // Returns a new jQuery collection with all unique elements
    $.fn.unique = function () {
        return this.pushStack($.unique(this));
    };

    /*
    * This method is similar to clone with the exception that
    * it will return an array of all of the clones of the element.
    */
    $.fn.duplicate = function (count, cloneEvents) {
        var tmp = [];
        for (var i = 0; i < count; i++) {
            $.merge(tmp, this.clone(cloneEvents).get());
        }
        return this.pushStack(tmp);
    };

    // Returns an array of values
    $.fn.values = function () {
        var values = [];
        this.each(function () {
            values.push($(this).val());
        });
        return values;
    };

    // Returns a string of joined values
    $.fn.joinValues = function (delim) {
        return this.values().join(arguments.length == 0 ? ',' : delim);
    };

    // Returns the value of the first element that contains the specified attribute
    // otherwise returns an empty string
    $.fn.firstAttr = function (attr) {
        var ret = '';
        this.each(function () {
            var r = $(this).attr(attr);
            if (r != '') {
                ret = r;
                return false;
            }
        });
        return ret;
    };

    $.extend({
        //Retrieves the type of an object. in case of null/array returns specific types 'null', 'array' instead generic type object
        typeOf: function (value) {
            var s = typeof value;
            if (s == 'object') {
                if (value) {
                    if (typeof value.length == 'number' &&
						!(value.propertyIsEnumerable('length')) &&
						typeof value.splice == 'function') {
                        s = 'array';
                    }
                } else {
                    s = 'null';
                }
            }
            return s;
        }
    });

    // Usage:
    // $('a').wait(5000, ['hello', 'world'], function(a, b) {
    //   alert( a + ' ' + b );
    //   $(this).addClass('highlight-links');
    // });
    $.fn.wait = function (timeout, data, fn) {
        if ($.isFunction(data)) {
            fn = data;
            data = [];
        }
        var _this = this;
        setTimeout(function () {
            _this.each(function () {
                fn.call(this, data);
            });
        }, timeout);
        return this;
    };

    // This method connects one dom event to another
    /*
    * This method is used to cross bind events. For example you can bind the click event of #element1
    * to the updateList custom event of #element2 by doing:
    * $('#element1').connect('click', '#element2', 'updateList');
    */
    $.fn.connect = function (/*[propagation, ]sourceEvent, target, targetEvent [, argsArray]*/) {
        var sourceHandling = false;
        var i = 0;
        if (typeof arguments[0] === 'boolean' || typeof arguments[0] == 'object') {
            sourceHandling = arguments[0];
            i++;
        }
        var sourceEvent = arguments[i++],
			target = arguments[i++],
			targetEvent = arguments[i++] || null,
			args = arguments[i] || null;

        return this.bind(sourceEvent, function (evt) {
            var _args = args;
            // If the user didn't specify any arguments, pass through the events args
            // (very useful for custom events)
            if (_args === null) {
                _args = Array.prototype.slice.call(arguments, 1);
            }
            $(target || this).trigger(targetEvent || sourceEvent, _args || []);
            if (typeof sourceHandling === 'object') {
                if (sourceHandling.stopPropagation === true) {
                    evt.stopPropagation();
                }
                if (sourceHandling.preventDefault === true) {
                    evt.preventDefault();
                }
                if (sourceHandling.stopImmediatePropagation === true) {
                    evt.stopImmediatePropagation();
                }
            }
            return sourceEvent;
        });
    };

    $.fn.clearForm = function () {
        return this.each(function () {
            var $t = $(this);
            var type = $t.attr('type');
            var tag = this.tagName.toLowerCase(); // normalize case
            // it's ok to reset the value attr of text inputs,
            // password inputs, and textareas
            if (type == 'text' || type == 'password' || tag == 'textarea' || tag == 'select') {
                if (tag == 'select') {
                    $t.attr('selectedIndex', -1);
                }
                $t.val('');
                // checkboxes and radios need to have their checked state cleared
                // but should *not* have their 'value' changed
            } else if (type == 'checkbox' || type == 'radio') {
                $t.attr('checked', false);
            }
        });
    };

    /*
    * This method is used heavily in Admin and ReferenceUSA (but was replaced with 
    * getInputValues in DirectoriesUSA. getInputValues() should be preferred over this
    * method. (Consider this @deprecated)
    */
    $.fn.getFormFields = function (override) {
        override = override || {};
        var data = {};
        this.each(function () {
            var id = $(this).attr('name') || $(this).attr('id');
            if (override[id]) {
                if ($.isFunction(override[id])) {
                    data[id] = override[id].call(this);
                } else {
                    if ($(override[id]).is(':radio')) {
                        if ($(override[id]).is(':checked')) {
                            data[id] = $(this).val();
                        }
                    } else if ($(override[id]).is(':checkbox')) {
                        data[id] = $(override[id]).is(':checked');
                    } else {
                        data[id] = $(override[id]).val();
                    }
                }
            } else {
                if ($(this).is(':radio')) {
                    if ($(this).is(':checked')) {
                        data[id] = $(this).val();
                    }
                } else if ($(this).is(':checkbox')) {
                    data[id] = $(this).is(':checked');
                } else {
                    data[id] = $(this).val();
                }
            }
        });
        return data;
    };

    /*
    * This method replaces getFormFields. This is the preferred method for gathering
    * form input.
    */
    $.fn.getInputValues = function (extra, allFields) {
        if (arguments.length == 1 && typeof extra == 'boolean') {
            allFields = extra;
            extra = null;
        }
        var data = {};
        var elements = this;
        if (this.is('form') || !this.is(':input')) {
            elements = $(this).find(':input');
        }
        elements.each(function () {
            var $t = $(this);
            var $e = $t.is(':hidden') ? $t.parent() : $t;
            if (allFields === true || $e.is(':visible')) {
                // Find the closest element that has either a name attribute or an id attribute
                var tmp = $t.closest('[name],[id]');
                var id = tmp.attr('name') || tmp.attr('id');
                if (($t.is(':checkbox,:radio') && !$t.is(':checked')) ||
					 ($t.is(':text') && $t.val() == '')) {
                    return;
                }

                if (data[id] === undefined) {
                    data[id] = $t.val();
                } else {
                    data[id] = $.makeArray(data[id]);
                    data[id].push($t.val());
                }
            }
        });
        if (extra) {
            $.extend(data, extra);
        }
        return data;
    };

    /*
    * This is a unique method that generates a string selector for the element passed in.
    */
    $.fn.getSelector = function (useClass) {
        if (this.length == 0) {
            return '';
        }
        var selector = '';
        var tag = $(this).eq(0).attr('tagName').toLowerCase();
        selector += tag;
        if ($(this).eq(0).is(':input')) {
            if (tag == 'input') {
                selector += '[type=' + ($(this).eq(0).attr('type') || '').toLowerCase() + ']';
            }
            selector += '[name=' + ($(this).eq(0).attr('name') || '') + ']';
        }

        var id = '#' + ($(this).eq(0).attr('id') || '');
        if (id != '#') {
            selector += id;
        }
        if (useClass !== false) {
            var kls = ($(this).eq(0).attr('className') || '').replace(/\s+/, '.');
            selector += (kls != '' ? '.' + kls : '');
        }
        return selector;
    };

    /*
    * This method takes an element or string of HTML and first checks if that
    * snippit of markup already exists. If it does, it returns the matched element.
    * Otherwise, it creates the specified markup and inserts into the DOM.
    */
    $.fn.createIfNonExistent = function (html) {
        var html = $(html);
        var element = $(this).find(html.getSelector());
        if (element.length == 0) {
            return html.prependTo(this);
        }
        return element;
    };

    /*
    * This method checks for the existence of a given selector and when it becomes available (exists on the DOM)
    * the callback method is triggered. By default this method will wait 2 seconds before expiring (which executes
    * the callback).
    */
    $.fn.whenAvailable = function (callback, expires) {
        if (arguments.length < 2 || (expires !== 0 && !expires)) {
            expires = 2000;
        }
        var start = new Date();
        // Grab our context
        if (this.length == 0) {
            // Freeze our selector and context
            setTimeout((function whenAvailable(selector, context, timeout) {
                return function () {
                    var query = $(selector, context);
                    var expired = (expires > 0 ? (new Date()) - start > expires : false);
                    if (query.length == 0 && !expired) {
                        //log('whenAvailable: not now ' + timeout + ' ' + ( ( new Date() ) - start) );
                        setTimeout(whenAvailable(selector, context, ((timeout + 10) > 350 ? 350 : timeout + 10)), timeout);
                    } else {
                        //log('whenAvailable: now! ' + ( (new Date()) - start ) );
                        callback.call(query, expired);
                    }
                };
            })(this.selector, this.context, 25), 25);
        } else {
            callback.call(this, false);
            //log('whenAvailable: immediately');
        }
        return this;
    };

    /*
    * This method checks for the availability of a specified input field and when it becomes 
    * available, sets focus to it.
    */
    $.fn.autoFocus = function (timeout) {
        this.whenAvailable(function () {
            if ($('.steal-focus').length == 0)
                $(this).trigger('origin-focusin').focus();
            else
                $('.steal-focus').trigger('origin-focusin').focus();
        }, timeout || 3000);
    };

    /*
    * This method watermark's an input value
    */
    $.fn.waterMark = function (text) {
        return this.each(function () {
            var val = $(this).val();
            var watermark = (arguments.length == 1 ? text : $(this).dataset('watermark')) || '';

            if (val.isNullOrEmpty()) {
                $(this)
					.val(watermark)
					.addClass('ignoreCriteriaInput');
            } else if (val !== watermark) {
                $(this).removeClass('watermark ignoreCriteriaInput');
            }

            $(this)
				.bind('focus change blur', function (evt) {
				    var _this = $(this);
				    var v = _this.val();
				    var hasValue = v != '' && v != watermark;
				    var focus = evt.type == 'focus';

				    _this.toggleClass('watermark ignoreCriteriaInput', !focus && !hasValue);
				    if (!hasValue) {
				        focus ? _this.val('') : _this.val(watermark);
				    }
				});
        });
    };

    $.fn.getWaterMarkVal = function () {
		var $control = $(this);
		var val = $control.val();
		var watermark = $control.dataset('watermark');
		if (val != watermark)
			return val;
		return '';
	};

	/*
    * This method checks if an element is with in the visibile region of the window.
    * Returns true if the element is with in the visibile region of the window, otherwise
    * returns false. This will also return false if the element is not available.
    */
    $.fn.isElementWithInTheView = function () {
        var $elem = $(this);
        // Check if the element is available
        if (!$elem || $elem.length == 0) return false;

        // Get the top & bottom coordinates of the window and the element.
        var docTop = $(window).scrollTop();
        var docBottom = docTop + $(window).height();
        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        // Is the element with in the visible region of the window.
        return ((docTop <= elemTop) && (docBottom >= elemBottom));
    };

    /*
    * This method checks if an element is with in the visibile region of the window.
    * If it doesn't, then window will be scrolled such that the element will become visible.
    */
    $.fn.scrollElementIntoView = function () {
        var $elem = $(this);

        // Check if the element is available and is not in the visible region.
        if ($elem.length > 0 && !$elem.isElementWithInTheView()) {
            // Okay, we need to scroll the window now.
            window.scrollBy(0, $elem.offset().top + $elem.height() - $(window).scrollTop());
        }

        return this;
    };

})(jQuery);